import ReportPanel from './panel'
import ReportStats from './stats'
import ReportExport from './export'

import { LAYOUT_REPORT_PANEL, LAYOUT_REPORT_STATS_ROOT, LAYOUT_REPORT_EXPORT_ROOT } from './navigation'

const routes = [
  {
    path: LAYOUT_REPORT_PANEL,
    component: ReportPanel,
    allowToOneOf: ['ROLE_TYPE_MANAGER']
  },
  {
    path: LAYOUT_REPORT_STATS_ROOT,
    component: ReportStats,
    allowToOneOf: ['ROLE_TYPE_MANAGER']
  },
  {
    path: LAYOUT_REPORT_EXPORT_ROOT,
    component: ReportExport,
    allowToOneOf: ['ROLE_TYPE_MANAGER']
  }
]

export default routes
